// extracted by mini-css-extract-plugin
module.exports =  {"currentPackage":"kBXUZga6rGDVxHp_tkgW"};